module.exports = __webpack_public_path__ + "internet.png?820cb7ca83dcc489f7eb794ccd5e2b9e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/empty/internet.png
// module id = 28
// module chunks = 0